var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKiveUsoComercialGraficoEscolar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 406.6 50",
    style: {
      enableBackground: "new 0 0 406.6 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FA0091;}\n\t.st1{fill:none;stroke:#FA0091;stroke-width:0.75;stroke-miterlimit:10;}\n\t.st2{enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 7.4,
    className: "st0",
    width: 8.9,
    height: 36.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 7.4,
    className: "st0",
    width: 8.9,
    height: 36.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.8,
    y: 7.4,
    className: "st0",
    width: 8.9,
    height: 36.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.4,
    y: 7.4,
    className: "st0",
    width: 8.9,
    height: 36.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "28.2,7.4 38.3,7.4 25.5,24.9 15.8,24.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "81.7,7.4 93.7,7.4 66.9,43.7 66.9,27.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "25.8,26.2 15.8,26.2 28.6,43.7 38.3,43.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "127.8,5.2 122.3,11.8 132.6,24.9 142.3,24.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "132.2,26.2 142.3,26.2 127.8,45 121.8,38.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 7.4,
    className: "st0",
    width: 13.9,
    height: 7.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 21.4,
    className: "st0",
    width: 8.4,
    height: 7.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 35.8,
    className: "st0",
    width: 13.9,
    height: 7.9
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M159.2,20.9c0.7,0.7,1.7,1.1,3,1.1c1.3,0,2.2-0.4,3-1.1c0.7-0.7,1.1-1.7,1.1-2.9V8.6h3.2V18 c0,1.4-0.3,2.6-0.9,3.6c-0.6,1-1.4,1.8-2.5,2.3c-1.1,0.5-2.4,0.8-3.8,0.8c-1.5,0-2.8-0.3-3.9-0.8s-1.9-1.3-2.5-2.3 c-0.6-1-0.9-2.2-0.9-3.6V8.6h3.2V18C158.1,19.2,158.4,20.2,159.2,20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181,11.6c-0.9-0.3-1.7-0.4-2.4-0.4c-0.8,0-1.4,0.1-1.8,0.4c-0.4,0.3-0.7,0.6-0.7,1.1c0,0.4,0.2,0.8,0.5,1.1 c0.3,0.3,0.7,0.5,1.2,0.7c0.5,0.2,1.1,0.4,1.9,0.6c1.1,0.3,2.1,0.6,2.8,1c0.7,0.3,1.3,0.8,1.8,1.4s0.8,1.4,0.8,2.4 c0,1-0.3,1.8-0.8,2.5s-1.3,1.3-2.3,1.6c-1,0.4-2.1,0.6-3.3,0.6c-1.3,0-2.6-0.2-3.8-0.7c-1.2-0.5-2.3-1.1-3.2-1.8l1.3-2.6 c0.8,0.7,1.8,1.3,2.8,1.7s2,0.6,2.9,0.6c0.9,0,1.6-0.2,2.1-0.5c0.5-0.3,0.8-0.8,0.8-1.3c0-0.5-0.2-0.8-0.5-1.1 c-0.3-0.3-0.7-0.5-1.2-0.7c-0.5-0.2-1.1-0.4-2-0.6c-1.1-0.3-2-0.6-2.8-0.9c-0.7-0.3-1.3-0.8-1.8-1.4c-0.5-0.6-0.8-1.4-0.8-2.4 c0-0.9,0.3-1.7,0.8-2.4c0.5-0.7,1.2-1.2,2.2-1.6c0.9-0.4,2-0.6,3.3-0.6c1.1,0,2.1,0.2,3.2,0.5c1.1,0.3,2,0.7,2.8,1.2l-1.3,2.7 C182.8,12.2,181.9,11.8,181,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200.2,9.5c1.4,0.7,2.4,1.7,3.2,2.9c0.8,1.2,1.2,2.6,1.2,4.1s-0.4,2.9-1.2,4.1c-0.8,1.2-1.8,2.2-3.2,3 c-1.4,0.7-2.9,1.1-4.5,1.1c-1.7,0-3.2-0.4-4.5-1.1c-1.4-0.7-2.4-1.7-3.2-3c-0.8-1.2-1.2-2.6-1.2-4.1s0.4-2.9,1.2-4.1 c0.8-1.2,1.8-2.2,3.2-2.9s2.9-1.1,4.5-1.1C197.4,8.4,198.9,8.8,200.2,9.5z M192.9,11.9c-0.9,0.5-1.6,1.1-2.1,1.9 c-0.5,0.8-0.8,1.7-0.8,2.7s0.3,1.9,0.8,2.7s1.2,1.5,2.1,2c0.9,0.5,1.8,0.7,2.8,0.7c1,0,1.9-0.2,2.8-0.7c0.9-0.5,1.5-1.1,2-2 s0.8-1.7,0.8-2.7s-0.2-1.9-0.8-2.7s-1.2-1.5-2-1.9s-1.8-0.7-2.8-0.7C194.7,11.2,193.8,11.4,192.9,11.9z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.2,11.7c-0.8-0.4-1.6-0.5-2.4-0.5c-1,0-2,0.2-2.8,0.7c-0.9,0.5-1.5,1.1-2,1.9c-0.5,0.8-0.7,1.7-0.7,2.7 s0.2,1.9,0.7,2.7c0.5,0.8,1.2,1.5,2,1.9c0.9,0.5,1.8,0.7,2.8,0.7c0.8,0,1.6-0.2,2.4-0.5c0.8-0.3,1.5-0.8,2.1-1.4l1.9,2 c-0.9,0.8-1.9,1.5-3,2c-1.2,0.5-2.3,0.7-3.5,0.7c-1.6,0-3.1-0.4-4.4-1.1c-1.3-0.7-2.4-1.7-3.1-3c-0.8-1.2-1.1-2.6-1.1-4.1 s0.4-2.9,1.2-4.1c0.8-1.2,1.8-2.2,3.2-2.9s2.8-1.1,4.5-1.1c1.2,0,2.4,0.2,3.5,0.7c1.1,0.5,2.1,1.1,2.9,1.9l-1.9,2.2 C224.7,12.6,224,12.1,223.2,11.7z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.5,9.5c1.4,0.7,2.4,1.7,3.2,2.9c0.8,1.2,1.2,2.6,1.2,4.1s-0.4,2.9-1.2,4.1c-0.8,1.2-1.8,2.2-3.2,3 c-1.4,0.7-2.9,1.1-4.5,1.1c-1.7,0-3.2-0.4-4.5-1.1c-1.4-0.7-2.4-1.7-3.2-3c-0.8-1.2-1.2-2.6-1.2-4.1s0.4-2.9,1.2-4.1 s1.8-2.2,3.2-2.9c1.4-0.7,2.9-1.1,4.5-1.1C238.7,8.4,240.2,8.8,241.5,9.5z M234.2,11.9c-0.9,0.5-1.6,1.1-2.1,1.9 c-0.5,0.8-0.8,1.7-0.8,2.7s0.3,1.9,0.8,2.7s1.2,1.5,2.1,2c0.9,0.5,1.8,0.7,2.8,0.7c1,0,1.9-0.2,2.8-0.7c0.9-0.5,1.5-1.1,2-2 s0.8-1.7,0.8-2.7s-0.2-1.9-0.8-2.7s-1.2-1.5-2-1.9s-1.8-0.7-2.8-0.7C236.1,11.2,235.1,11.4,234.2,11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M248.7,8.6h3.6l5.5,10.2l5.5-10.2h3.6v15.9h-2.9V13.1l-5.2,9.7h-2l-5.2-9.7v11.4h-2.9V8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271.1,8.6h12.2v2.7h-9v3.9h8.1v2.7h-8.1v4h9.3v2.7h-12.5V8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M297.2,24.5l-2.9-4.7c-0.1,0-0.3,0-0.6,0H290v4.7h-3.2V8.6h7c2.2,0,3.8,0.5,5,1.4c1.2,1,1.8,2.3,1.8,4 c0,1.2-0.3,2.3-0.8,3.2c-0.6,0.9-1.4,1.5-2.5,2l3.7,5.3H297.2z M290,17.2h3.8c1.2,0,2.1-0.2,2.8-0.7c0.6-0.5,1-1.2,1-2.2 c0-1-0.3-1.7-1-2.2c-0.6-0.5-1.6-0.7-2.8-0.7H290V17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M314,11.7c-0.8-0.4-1.6-0.5-2.4-0.5c-1,0-2,0.2-2.8,0.7c-0.9,0.5-1.5,1.1-2,1.9s-0.7,1.7-0.7,2.7 s0.2,1.9,0.7,2.7s1.2,1.5,2,1.9s1.8,0.7,2.8,0.7c0.8,0,1.6-0.2,2.4-0.5s1.5-0.8,2.1-1.4l1.9,2c-0.9,0.8-1.9,1.5-3,2 c-1.2,0.5-2.3,0.7-3.5,0.7c-1.6,0-3.1-0.4-4.4-1.1c-1.3-0.7-2.4-1.7-3.1-3c-0.8-1.2-1.1-2.6-1.1-4.1s0.4-2.9,1.2-4.1 c0.8-1.2,1.8-2.2,3.2-2.9c1.3-0.7,2.8-1.1,4.5-1.1c1.2,0,2.4,0.2,3.5,0.7c1.1,0.5,2.1,1.1,2.9,1.9l-1.9,2.2 C315.5,12.6,314.8,12.1,314,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M320.6,8.6h3.2v15.9h-3.2V8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340.2,24.5l-1.5-3.4h-8.1l-1.5,3.4h-3.3l7.3-15.9h3.3l7.2,15.9H340.2z M331.7,18.5h5.9l-2.9-6.7L331.7,18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M345.7,8.6h3.2v13.1h7.2v2.7h-10.4V8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M360.3,21.9c0.3,0.3,0.5,0.7,0.5,1.2c0,0.2,0,0.4-0.1,0.6c-0.1,0.2-0.2,0.4-0.3,0.7l-1.5,2.7h-1.5l1-2.7 c-0.5-0.3-0.7-0.7-0.7-1.3c0-0.5,0.2-0.9,0.5-1.1c0.3-0.3,0.7-0.4,1.1-0.4C359.6,21.5,360,21.6,360.3,21.9z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M166.5,38.7h2.8v6c-0.9,0.6-1.9,1.1-3.1,1.5c-1.2,0.4-2.4,0.6-3.5,0.6c-1.6,0-3.1-0.4-4.5-1.1 c-1.3-0.7-2.4-1.7-3.2-3c-0.8-1.2-1.2-2.6-1.2-4.1c0-1.5,0.4-2.9,1.2-4.1c0.8-1.2,1.9-2.2,3.2-2.9c1.4-0.7,2.9-1.1,4.6-1.1 c1.2,0,2.4,0.2,3.5,0.6c1.2,0.4,2.2,1,3,1.7l-1.8,2.2c-0.6-0.6-1.4-1-2.2-1.3c-0.8-0.3-1.7-0.5-2.5-0.5c-1,0-2,0.2-2.9,0.7 c-0.9,0.5-1.6,1.1-2.1,2c-0.5,0.8-0.8,1.7-0.8,2.7c0,1,0.3,1.9,0.8,2.7c0.5,0.8,1.2,1.5,2.1,2c0.9,0.5,1.8,0.7,2.9,0.7 c0.6,0,1.2-0.1,1.8-0.3c0.6-0.2,1.2-0.4,1.8-0.7V38.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.4,46.6l-2.9-4.7c-0.1,0-0.3,0-0.6,0h-3.8v4.7H173V30.7h7c2.2,0,3.8,0.5,5,1.4c1.2,1,1.8,2.3,1.8,4 c0,1.2-0.3,2.3-0.8,3.2c-0.6,0.9-1.4,1.5-2.5,2l3.7,5.3H183.4z M176.2,39.3h3.8c1.2,0,2.1-0.2,2.8-0.7s1-1.2,1-2.2 c0-1-0.3-1.7-1-2.2c-0.6-0.5-1.6-0.7-2.8-0.7h-3.8V39.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M202.5,46.6l-1.5-3.4h-8.1l-1.5,3.4h-3.3l7.3-15.9h3.3l7.2,15.9H202.5z M194,40.6h5.9L197,34L194,40.6z  M197.9,26l3,1.2l-3,2.3l-2.4-0.2L197.9,26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208,30.7h11.5l0,2.7h-8.3v4.3h7.5v2.7h-7.5v6.3H208V30.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M221.8,30.7h3.2v15.9h-3.2V30.7z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M239.1,33.8c-0.8-0.4-1.6-0.5-2.4-0.5c-1,0-2,0.2-2.8,0.7c-0.9,0.5-1.5,1.1-2,1.9s-0.7,1.7-0.7,2.7 s0.2,1.9,0.7,2.7s1.2,1.5,2,1.9c0.9,0.5,1.8,0.7,2.8,0.7c0.8,0,1.6-0.2,2.4-0.5s1.5-0.8,2.1-1.4l1.9,2c-0.9,0.8-1.9,1.5-3,2 c-1.2,0.5-2.3,0.7-3.5,0.7c-1.6,0-3.1-0.4-4.4-1.1c-1.3-0.7-2.4-1.7-3.1-3s-1.1-2.6-1.1-4.1c0-1.5,0.4-2.9,1.2-4.1 c0.8-1.2,1.8-2.2,3.2-2.9c1.3-0.7,2.8-1.1,4.5-1.1c1.2,0,2.4,0.2,3.5,0.7s2.1,1.1,2.9,1.9l-1.9,2.2 C240.6,34.7,239.9,34.2,239.1,33.8z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M257.4,31.6c1.4,0.7,2.4,1.7,3.2,2.9c0.8,1.2,1.2,2.6,1.2,4.1c0,1.5-0.4,2.9-1.2,4.1c-0.8,1.2-1.8,2.2-3.2,3 c-1.4,0.7-2.9,1.1-4.5,1.1s-3.2-0.4-4.5-1.1c-1.4-0.7-2.4-1.7-3.2-3s-1.2-2.6-1.2-4.1c0-1.5,0.4-2.9,1.2-4.1 c0.8-1.2,1.8-2.2,3.2-2.9s2.9-1.1,4.5-1.1S256.1,30.9,257.4,31.6z M250.1,34c-0.9,0.5-1.6,1.1-2.1,2c-0.5,0.8-0.8,1.7-0.8,2.7 c0,1,0.3,1.9,0.8,2.7c0.5,0.8,1.2,1.5,2.1,2s1.8,0.7,2.8,0.7c1,0,1.9-0.2,2.8-0.7c0.9-0.5,1.5-1.1,2-2c0.5-0.8,0.8-1.7,0.8-2.7 c0-1-0.2-1.9-0.8-2.7s-1.2-1.5-2-2c-0.9-0.5-1.8-0.7-2.8-0.7C252,33.3,251,33.5,250.1,34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M283.8,30.7l-6.1,10.7v5.2h-3.2v-5.1l-6.2-10.8h3.2l4.5,7.5l4.5-7.5H283.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M291.7,30.7h12.2v2.7h-9v3.9h8.1V40h-8.1v4h9.3v2.7h-12.5V30.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M315.3,33.7c-0.9-0.3-1.7-0.4-2.4-0.4c-0.8,0-1.4,0.1-1.8,0.4c-0.4,0.3-0.7,0.6-0.7,1.1c0,0.4,0.2,0.8,0.5,1.1 c0.3,0.3,0.7,0.5,1.2,0.7c0.5,0.2,1.1,0.4,1.9,0.6c1.1,0.3,2.1,0.6,2.8,1c0.7,0.3,1.3,0.8,1.8,1.4c0.5,0.6,0.8,1.4,0.8,2.4 c0,1-0.3,1.8-0.8,2.5c-0.5,0.7-1.3,1.3-2.3,1.6s-2.1,0.6-3.3,0.6c-1.3,0-2.6-0.2-3.8-0.7s-2.3-1.1-3.2-1.8l1.3-2.6 c0.8,0.7,1.8,1.3,2.8,1.7c1,0.4,2,0.6,2.9,0.6c0.9,0,1.6-0.2,2.1-0.5c0.5-0.3,0.8-0.8,0.8-1.3c0-0.5-0.2-0.8-0.5-1.1 c-0.3-0.3-0.7-0.5-1.2-0.7s-1.1-0.4-2-0.6c-1.1-0.3-2-0.6-2.8-0.9c-0.7-0.3-1.3-0.8-1.8-1.4s-0.8-1.4-0.8-2.4 c0-0.9,0.3-1.7,0.8-2.4s1.2-1.2,2.2-1.6c0.9-0.4,2-0.6,3.3-0.6c1.1,0,2.1,0.2,3.2,0.5c1.1,0.3,2,0.7,2.8,1.2l-1.3,2.7 C317.1,34.3,316.2,33.9,315.3,33.7z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M332.4,33.8c-0.8-0.4-1.6-0.5-2.4-0.5c-1,0-2,0.2-2.8,0.7c-0.9,0.5-1.5,1.1-2,1.9c-0.5,0.8-0.7,1.7-0.7,2.7 s0.2,1.9,0.7,2.7c0.5,0.8,1.2,1.5,2,1.9c0.9,0.5,1.8,0.7,2.8,0.7c0.8,0,1.6-0.2,2.4-0.5c0.8-0.3,1.5-0.8,2.1-1.4l1.9,2 c-0.9,0.8-1.9,1.5-3,2c-1.2,0.5-2.3,0.7-3.5,0.7c-1.6,0-3.1-0.4-4.4-1.1c-1.3-0.7-2.4-1.7-3.1-3s-1.1-2.6-1.1-4.1 c0-1.5,0.4-2.9,1.2-4.1c0.8-1.2,1.8-2.2,3.2-2.9s2.8-1.1,4.5-1.1c1.2,0,2.4,0.2,3.5,0.7s2.1,1.1,2.9,1.9l-1.9,2.2 C333.9,34.7,333.2,34.2,332.4,33.8z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M350.7,31.6c1.4,0.7,2.4,1.7,3.2,2.9c0.8,1.2,1.2,2.6,1.2,4.1c0,1.5-0.4,2.9-1.2,4.1s-1.8,2.2-3.2,3 c-1.4,0.7-2.9,1.1-4.5,1.1c-1.7,0-3.2-0.4-4.5-1.1c-1.4-0.7-2.4-1.7-3.2-3c-0.8-1.2-1.2-2.6-1.2-4.1c0-1.5,0.4-2.9,1.2-4.1 c0.8-1.2,1.8-2.2,3.2-2.9s2.9-1.1,4.5-1.1C347.8,30.5,349.3,30.9,350.7,31.6z M343.4,34c-0.9,0.5-1.6,1.1-2.1,2s-0.8,1.7-0.8,2.7 c0,1,0.3,1.9,0.8,2.7c0.5,0.8,1.2,1.5,2.1,2c0.9,0.5,1.8,0.7,2.8,0.7c1,0,1.9-0.2,2.8-0.7c0.9-0.5,1.5-1.1,2-2 c0.5-0.8,0.8-1.7,0.8-2.7c0-1-0.2-1.9-0.8-2.7s-1.2-1.5-2-2c-0.9-0.5-1.8-0.7-2.8-0.7C345.2,33.3,344.3,33.5,343.4,34z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M357.9,30.7h3.2v13.1h7.2v2.7h-10.4V30.7z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M383.2,46.6l-1.5-3.4h-8.1l-1.5,3.4h-3.3l7.3-15.9h3.3l7.2,15.9H383.2z M374.7,40.6h5.9l-2.9-6.7L374.7,40.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M399.1,46.6l-2.9-4.7c-0.1,0-0.3,0-0.6,0h-3.8v4.7h-3.2V30.7h7c2.2,0,3.8,0.5,5,1.4c1.2,1,1.8,2.3,1.8,4 c0,1.2-0.3,2.3-0.8,3.2c-0.6,0.9-1.4,1.5-2.5,2l3.7,5.3H399.1z M391.8,39.3h3.8c1.2,0,2.1-0.2,2.8-0.7s1-1.2,1-2.2 c0-1-0.3-1.7-1-2.2c-0.6-0.5-1.6-0.7-2.8-0.7h-3.8V39.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiveUsoComercialGraficoEscolar);
export default __webpack_public_path__ + "static/media/kive-uso-comercial-grafico-escolar.ae75539544f77cb400de63aa1696e885.svg";
export { ForwardRef as ReactComponent };